import angular from "angular"
import React, { useState } from "react" // eslint-disable-line no-unused-vars
import Button from "@paprika/button"
import { react2angular } from "react2angular"
import "./highlights.scss"

function Highlights(props) {
  const [toggleStates, setToggleStates] = useState({
    rentals: false,
    sales: false,
  })

  // Styles are now handled in SCSS with proper media queries

  const handleToggle = (type) => {
    const newState = !toggleStates[type]
    setToggleStates((prev) => ({
      ...prev,
      [type]: newState,
    }))
    props.onClickHighlight(type, newState)
  }

  return (
    <div className="highlights-container">
      <Button
        kind={Button.types.kind.FLAT}
        className={`highlights-button highlights-button-rentals ${
          toggleStates.rentals ? "highlights-button-active" : ""
        }`}
        onClick={() => handleToggle("rentals")}
      >
        🏠 {toggleStates.rentals ? "Hide Rentals" : "Show Rentals"}
      </Button>
      <Button
        kind={Button.types.kind.FLAT}
        className={`highlights-button highlights-button-sales ${toggleStates.sales ? "highlights-button-active" : ""}`}
        onClick={() => handleToggle("sales")}
      >
        🏷️ {toggleStates.sales ? "Hide Sales" : "Show Sales"}
      </Button>
    </div>
  )
}

export default angular
  .module("makeamapAngularApp.highlights", [])
  .component("highlights", react2angular(Highlights, ["onClickHighlight"])).name
